import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

export const CommonError = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'border-primary transition-opacity flex min-w-0 flex-1 flex-col overflow-hidden rounded-3xl border bg-white shadow-sm',
        className
      )}>
      <div className='flex flex-1 items-center justify-center p-12'>
        <p className='text-destructive text-sm'>{t('common.error')}</p>
      </div>
    </div>
  );
};
